import { WorkflowTrigger, WorkflowTriggerName } from '@frontend/workflow/types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export enum TransactionTriggerName {
    TRANSACTION_PROCESS = 'transaction_process',
    TRANSACTION_CANCEL = 'transaction_cancel',
    TRANSACTION_COMPLETE = 'transaction_complete',
    TRANSACTION_STATE_CHANGED = 'transaction_state_changed',
    TRANSACTION_PACKAGE_PROCESSED = 'transaction_package_processed',
    TRANSACTION_PACKAGE_CANCELLED = 'transaction_package_cancelled',
    TRANSACTION_PACKAGE_FAILED = 'transaction_package_failed',
    TRANSACTION_COLLI_PROCESSED = 'transaction_colli_processed',
    TRANSACTION_COLLI_CANCELLED = 'transaction_colli_cancelled',
    TRANSACTION_COLLI_FAILED = 'transaction_colli_failed',
    TRANSACTION_PROCESSED = 'transaction_processed',
    TRANSACTION_PROCESSED_WITH_FAILURES = 'transaction_processed_with_failures',
    TRANSACTION_CANCELLED = 'transaction_cancelled',
    TRANSACTION_FAILED = 'transaction_failed',
    TRANSACTION_ANNOUNCED = 'transaction_announced',
    TRANSACTION_ACCEPTED_BY_COURIER = 'transaction_accepted_by_courier',
    TRANSACTION_HANDED_IN_BY_CUSTOMER = 'transaction_handed_in_by_customer',
    TRANSACTION_PICKED_UP_BY_COURIER = 'transaction_picked_up_by_courier',
    TRANSACTION_SORTED_BY_COURIER = 'transaction_sorted_by_courier',
    TRANSACTION_MIS_SORTED_BY_COURIER = 'transaction_mis_sorted_by_courier',
    TRANSACTION_REDIRECTED_BY_COURIER = 'transaction_redirected_by_courier',
    TRANSACTION_DELIVERED_BY_COURIER = 'transaction_delivered_by_courier',
    TRANSACTION_PICKED_UP_BY_CUSTOMER = 'transaction_picked_up_by_customer',
    TRANSACTION_NOT_PICKED_UP_BY_CUSTOMER = 'transaction_not_picked_up_by_customer',
    TRANSACTION_DELIVERY_CONFIRMED = 'transaction_delivery_confirmed',
    TRANSACTION_PIN_CODE_CREATED = 'transaction_pin_code_created',
    TRANSACTION_PIN_CODE_ENTERED = 'transaction_pin_code_entered',
    TRANSACTION_SPOT_MOVED = 'transaction_spot_moved',
    TRANSACTION_DROPPED_OFF = 'transaction_dropped_off',
    TRANSACTION_PICKED_UP = 'transaction_picked_up',
    TRANSACTION_COURIER_TIMED_OUT = 'transaction_courier_timed_out',
    TRANSACTION_DROP_OFF = 'transaction_drop_off',
    TRANSACTION_PICK_UP = 'transaction_pick_up',
    TRANSACTION_LOST = 'transaction_lost',
    TRANSACTION_ACTUATOR_ERROR = 'transaction_actuator_error',
    TRANSACTION_MOVE_SLOT = 'transaction_move_slot',
    TRANSACTION_MOVE_SPOT = 'transaction_move_spot',
    TRANSACTION_OPEN_SLOT = 'transaction_open_slot',
    TRANSACTION_SLOT_CANCELLED = 'transaction_slot_cancelled',
    TRANSACTION_SLOT_CLOSED = 'transaction_slot_closed',
    TRANSACTION_SLOT_ERROR = 'transaction_slot_error',
    TRANSACTION_SLOT_MOVED = 'transaction_slot_moved',
    TRANSACTION_SLOT_NOT_CLOSED = 'transaction_slot_not_closed',
    TRANSACTION_SLOT_NOT_OPENED = 'transaction_slot_not_opened',
    TRANSACTION_SLOT_OPENED = 'transaction_slot_opened',
    TRANSACTION_SLOT_UNLOCKED = 'transaction_slot_unlocked',
    TRANSACTION_DELEGATED_TO_RECEIVER = 'transaction_delegate_to_receiver',
    TRANSACTION_DELEGATED_TO_SENDER = 'transaction_delegate_to_sender'
}

export class TransactionTrigger extends WorkflowTrigger {
    static readonly TRANSACTION_PROCESS = new TransactionTrigger(
        TransactionTriggerName.TRANSACTION_PROCESS,
        (
            <FormattedMessage
                id='TransactionTrigger.transaction_process'
                description='The displayed value for the TransactionTrigger transaction_process'
                defaultMessage='Transaction process'
            />
        )
    );
    static readonly TRANSACTION_STATE_CHANGED = new TransactionTrigger(
        TransactionTriggerName.TRANSACTION_STATE_CHANGED,
        (
            <FormattedMessage
                id='TransactionTrigger.transaction_state_changed'
                description='The displayed value for the TransactionTrigger transaction_state_changed'
                defaultMessage='Transaction state changed'
            />
        )
    );
    static readonly TRANSACTION_PACKAGE_PROCESSED = new TransactionTrigger(
        TransactionTriggerName.TRANSACTION_PACKAGE_PROCESSED,
        (
            <FormattedMessage
                id='TransactionTrigger.transaction_package_processed'
                description='The displayed value for the TransactionTrigger transaction_package_processed'
                defaultMessage='Transaction package processed'
            />
        )
    );
    static readonly TRANSACTION_PACKAGE_CANCELLED = new TransactionTrigger(
        TransactionTriggerName.TRANSACTION_PACKAGE_CANCELLED,
        (
            <FormattedMessage
                id='TransactionTrigger.transaction_package_cancelled'
                description='The displayed value for the TransactionTrigger transaction_package_cancelled'
                defaultMessage='Transaction package cancelled'
            />
        )
    );
    static readonly TRANSACTION_PACKAGE_FAILED = new TransactionTrigger(
        TransactionTriggerName.TRANSACTION_PACKAGE_FAILED,
        (
            <FormattedMessage
                id='TransactionTrigger.transaction_package_failed'
                description='The displayed value for the TransactionTrigger transaction_package_failed'
                defaultMessage='Transaction package failed'
            />
        )
    );
    static readonly TRANSACTION_COLLI_PROCESSED = new TransactionTrigger(
        TransactionTriggerName.TRANSACTION_COLLI_PROCESSED,
        (
            <FormattedMessage
                id='TransactionTrigger.transaction_colli_processed'
                description='The displayed value for the TransactionTrigger transaction_colli_processed'
                defaultMessage='Transaction colli processed'
            />
        )
    );
    static readonly TRANSACTION_COLLI_CANCELLED = new TransactionTrigger(
        TransactionTriggerName.TRANSACTION_COLLI_CANCELLED,
        (
            <FormattedMessage
                id='TransactionTrigger.transaction_colli_cancelled'
                description='The displayed value for the TransactionTrigger transaction_colli_cancelled'
                defaultMessage='Transaction colli cancelled'
            />
        )
    );
    static readonly TRANSACTION_COLLI_FAILED = new TransactionTrigger(
        TransactionTriggerName.TRANSACTION_COLLI_FAILED,
        (
            <FormattedMessage
                id='TransactionTrigger.transaction_colli_failed'
                description='The displayed value for the TransactionTrigger transaction_colli_failed'
                defaultMessage='Transaction colli failed'
            />
        )
    );
    static readonly TRANSACTION_PROCESSED = new TransactionTrigger(
        TransactionTriggerName.TRANSACTION_PROCESSED,
        (
            <FormattedMessage
                id='TransactionTrigger.transaction_processed'
                description='The displayed value for the TransactionTrigger transaction_processed'
                defaultMessage='Transaction processed'
            />
        )
    );
    static readonly TRANSACTION_CANCEL = new TransactionTrigger(
        TransactionTriggerName.TRANSACTION_CANCEL,
        (
            <FormattedMessage
                id='TransactionTrigger.transaction_cancel'
                description='The displayed value for the TransactionTrigger transaction_cancel'
                defaultMessage='Transaction cancel'
            />
        )
    );
    static readonly TRANSACTION_FAILED = new TransactionTrigger(
        TransactionTriggerName.TRANSACTION_FAILED,
        (
            <FormattedMessage
                id='TransactionTrigger.transaction_failed'
                description='The displayed value for the TransactionTrigger transaction_failed'
                defaultMessage='Transaction failed'
            />
        )
    );
    static readonly TRANSACTION_CANCELLED = new TransactionTrigger(
        TransactionTriggerName.TRANSACTION_CANCELLED,
        (
            <FormattedMessage
                id='TransactionTrigger.transaction_cancelled'
                description='The displayed value for the TransactionTrigger transaction_cancelled'
                defaultMessage='Transaction cancelled'
            />
        )
    );
    static readonly TRANSACTION_PROCESSED_WITH_FAILURES = new TransactionTrigger(
        TransactionTriggerName.TRANSACTION_PROCESSED_WITH_FAILURES,
        (
            <FormattedMessage
                id='TransactionTrigger.transaction_processed_with_failures'
                description='The displayed value for the TransactionTrigger transaction_processed_with_failures'
                defaultMessage='Transaction processed with failures'
            />
        )
    );
    static readonly TRANSACTION_ANNOUNCED = new TransactionTrigger(
        TransactionTriggerName.TRANSACTION_ANNOUNCED,
        (
            <FormattedMessage
                id='TransactionTrigger.transaction_announced'
                description='The displayed value for the TransactionTrigger transaction_announced'
                defaultMessage='Transaction announced'
            />
        )
    );
    static readonly TRANSACTION_ACCEPTED_BY_COURIER = new TransactionTrigger(
        TransactionTriggerName.TRANSACTION_ACCEPTED_BY_COURIER,
        (
            <FormattedMessage
                id='TransactionTrigger.transaction_accepted_by_courier'
                description='The displayed value for the TransactionTrigger transaction_accepted_by_courier'
                defaultMessage='Transaction accepted by courier'
            />
        )
    );
    static readonly TRANSACTION_HANDED_IN_BY_CUSTOMER = new TransactionTrigger(
        TransactionTriggerName.TRANSACTION_HANDED_IN_BY_CUSTOMER,
        (
            <FormattedMessage
                id='TransactionTrigger.transaction_handed_in_by_customer'
                description='The displayed value for the TransactionTrigger transaction_handed_in_by_customer'
                defaultMessage='Transaction handed in by customer'
            />
        )
    );
    static readonly TRANSACTION_PICKED_UP_BY_COURIER = new TransactionTrigger(
        TransactionTriggerName.TRANSACTION_PICKED_UP_BY_COURIER,
        (
            <FormattedMessage
                id='TransactionTrigger.transaction_picked_up_by_courier'
                description='The displayed value for the TransactionTrigger transaction_picked_up_by_courier'
                defaultMessage='Transaction picked up by courier'
            />
        )
    );
    static readonly TRANSACTION_SORTED_BY_COURIER = new TransactionTrigger(
        TransactionTriggerName.TRANSACTION_SORTED_BY_COURIER,
        (
            <FormattedMessage
                id='TransactionTrigger.transaction_sorted_by_courier'
                description='The displayed value for the TransactionTrigger transaction_sorted_by_courier'
                defaultMessage='Transaction sorted by courier'
            />
        )
    );
    static readonly TRANSACTION_MIS_SORTED_BY_COURIER = new TransactionTrigger(
        TransactionTriggerName.TRANSACTION_MIS_SORTED_BY_COURIER,
        (
            <FormattedMessage
                id='TransactionTrigger.transaction_mis_sorted_by_courier'
                description='The displayed value for the TransactionTrigger transaction_mis_sorted_by_courier'
                defaultMessage='Transaction mis-sorted by courier'
            />
        )
    );
    static readonly TRANSACTION_REDIRECTED_BY_COURIER = new TransactionTrigger(
        TransactionTriggerName.TRANSACTION_REDIRECTED_BY_COURIER,
        (
            <FormattedMessage
                id='TransactionTrigger.transaction_redirected_by_courier'
                description='The displayed value for the TransactionTrigger transaction_redirected_by_courier'
                defaultMessage='Transaction redirected by courier'
            />
        )
    );
    static readonly TRANSACTION_DELIVERED_BY_COURIER = new TransactionTrigger(
        TransactionTriggerName.TRANSACTION_DELIVERED_BY_COURIER,
        (
            <FormattedMessage
                id='TransactionTrigger.transaction_delivered_by_courier'
                description='The displayed value for the TransactionTrigger transaction_delivered_by_courier'
                defaultMessage='Transaction delivered by courier'
            />
        )
    );
    static readonly TRANSACTION_PICKED_UP_BY_CUSTOMER = new TransactionTrigger(
        TransactionTriggerName.TRANSACTION_PICKED_UP_BY_CUSTOMER,
        (
            <FormattedMessage
                id='TransactionTrigger.transaction_picked_up_by_customer'
                description='The displayed value for the TransactionTrigger transaction_picked_up_by_customer'
                defaultMessage='Transaction picked up by customer'
            />
        )
    );
    static readonly TRANSACTION_NOT_PICKED_UP_BY_CUSTOMER = new TransactionTrigger(
        TransactionTriggerName.TRANSACTION_NOT_PICKED_UP_BY_CUSTOMER,
        (
            <FormattedMessage
                id='TransactionTrigger.transaction_not_picked_up_by_customer'
                description='The displayed value for the TransactionTrigger transaction_not_picked_up_by_customer'
                defaultMessage='Transaction not picked up by customer'
            />
        )
    );
    static readonly TRANSACTION_DELIVERY_CONFIRMED = new TransactionTrigger(
        TransactionTriggerName.TRANSACTION_DELIVERY_CONFIRMED,
        (
            <FormattedMessage
                id='TransactionTrigger.transaction_delivery_confirmed'
                description='The displayed value for the TransactionTrigger transaction_delivery_confirmed'
                defaultMessage='Transaction delivery confirmed'
            />
        )
    );
    static readonly TRANSACTION_PIN_CODE_CREATED = new TransactionTrigger(
        TransactionTriggerName.TRANSACTION_PIN_CODE_CREATED,
        (
            <FormattedMessage
                id='TransactionTrigger.transaction_pin_code_created'
                description='The displayed value for the TransactionTrigger transaction_pin_code_created'
                defaultMessage='Transaction PIN-code created'
            />
        )
    );
    static readonly TRANSACTION_PIN_CODE_ENTERED = new TransactionTrigger(
        TransactionTriggerName.TRANSACTION_PIN_CODE_ENTERED,
        (
            <FormattedMessage
                id='TransactionTrigger.transaction_pin_code_entered'
                description='The displayed value for the TransactionTrigger transaction_pin_code_entered'
                defaultMessage='Transaction PIN-code entered'
            />
        )
    );
    static readonly TRANSACTION_SPOT_MOVED = new TransactionTrigger(
        TransactionTriggerName.TRANSACTION_SPOT_MOVED,
        (
            <FormattedMessage
                id='TransactionTrigger.transaction_spot_moved'
                description='The displayed value for the TransactionTrigger transaction_spot_moved'
                defaultMessage='Transaction SPOT moved'
            />
        )
    );
    static readonly TRANSACTION_DROPPED_OFF = new TransactionTrigger(
        TransactionTriggerName.TRANSACTION_DROPPED_OFF,
        (
            <FormattedMessage
                id='TransactionTrigger.transaction_dropped_off'
                description='The displayed value for the TransactionTrigger transaction_dropped_off'
                defaultMessage='Transaction dropped off'
            />
        )
    );
    static readonly TRANSACTION_PICKED_UP = new TransactionTrigger(
        TransactionTriggerName.TRANSACTION_PICKED_UP,
        (
            <FormattedMessage
                id='TransactionTrigger.transaction_picked_up'
                description='The displayed value for the TransactionTrigger transaction_picked_up'
                defaultMessage='Transaction picked up'
            />
        )
    );
    static readonly TRANSACTION_COURIER_TIMED_OUT = new TransactionTrigger(
        TransactionTriggerName.TRANSACTION_COURIER_TIMED_OUT,
        (
            <FormattedMessage
                id='TransactionTrigger.transaction_courier_timed_out'
                description='The displayed value for the TransactionTrigger transaction_courier_timed_out'
                defaultMessage='Transaction courier timed out'
            />
        )
    );
    static readonly TRANSACTION_DROP_OFF = new TransactionTrigger(
        TransactionTriggerName.TRANSACTION_DROP_OFF,
        (
            <FormattedMessage
                id='TransactionTrigger.transaction_drop_off'
                description='The displayed value for the TransactionTrigger transaction_drop_off'
                defaultMessage='Transaction drop-off'
            />
        )
    );
    static readonly TRANSACTION_PICK_UP = new TransactionTrigger(
        TransactionTriggerName.TRANSACTION_PICK_UP,
        (
            <FormattedMessage
                id='TransactionTrigger.transaction_pick_up'
                description='The displayed value for the TransactionTrigger transaction_pick_up'
                defaultMessage='Transaction pick-up'
            />
        )
    );
    static readonly TRANSACTION_COMPLETE = new TransactionTrigger(
        TransactionTriggerName.TRANSACTION_COMPLETE,
        (
            <FormattedMessage
                id='TransactionTrigger.transaction_complete'
                description='The displayed value for the TransactionTrigger transaction_complete'
                defaultMessage='Transaction complete'
            />
        )
    );
    static readonly TRANSACTION_LOST = new TransactionTrigger(
        TransactionTriggerName.TRANSACTION_LOST,
        (
            <FormattedMessage
                id='TransactionTrigger.transaction_lost'
                description='The displayed value for the TransactionTrigger transaction_lost'
                defaultMessage='Transaction lost'
            />
        )
    );
    static readonly TRANSACTION_ACTUATOR_ERROR = new TransactionTrigger(
        TransactionTriggerName.TRANSACTION_ACTUATOR_ERROR,
        (
            <FormattedMessage
                id='TransactionTrigger.transaction_actuator_error'
                description='The displayed value for the TransactionTrigger transaction_actuator_error'
                defaultMessage='Transaction actuator error'
            />
        )
    );
    static readonly TRANSACTION_MOVE_SLOT = new TransactionTrigger(
        TransactionTriggerName.TRANSACTION_MOVE_SLOT,
        (
            <FormattedMessage
                id='TransactionTrigger.transaction_move_slot'
                description='The displayed value for the TransactionTrigger transaction_move_slot'
                defaultMessage='Transaction move SLOT'
            />
        )
    );
    static readonly TRANSACTION_MOVE_SPOT = new TransactionTrigger(
        TransactionTriggerName.TRANSACTION_MOVE_SPOT,
        (
            <FormattedMessage
                id='TransactionTrigger.transaction_move_spot'
                description='The displayed value for the TransactionTrigger transaction_move_spot'
                defaultMessage='Transaction move SPOT'
            />
        )
    );
    static readonly TRANSACTION_OPEN_SLOT = new TransactionTrigger(
        TransactionTriggerName.TRANSACTION_OPEN_SLOT,
        (
            <FormattedMessage
                id='TransactionTrigger.transaction_open_slot'
                description='The displayed value for the TransactionTrigger transaction_open_slot'
                defaultMessage='Transaction open SLOT'
            />
        )
    );
    static readonly TRANSACTION_SLOT_CANCELLED = new TransactionTrigger(
        TransactionTriggerName.TRANSACTION_SLOT_CANCELLED,
        (
            <FormattedMessage
                id='TransactionTrigger.transaction_slot_cancelled'
                description='The displayed value for the TransactionTrigger transaction_slot_cancelled'
                defaultMessage='Transaction SLOT cancelled'
            />
        )
    );
    static readonly TRANSACTION_SLOT_CLOSED = new TransactionTrigger(
        TransactionTriggerName.TRANSACTION_SLOT_CLOSED,
        (
            <FormattedMessage
                id='TransactionTrigger.transaction_slot_closed'
                description='The displayed value for the TransactionTrigger transaction_slot_closed'
                defaultMessage='Transaction SLOT closed'
            />
        )
    );
    static readonly TRANSACTION_SLOT_ERROR = new TransactionTrigger(
        TransactionTriggerName.TRANSACTION_SLOT_ERROR,
        (
            <FormattedMessage
                id='TransactionTrigger.transaction_slot_error'
                description='The displayed value for the TransactionTrigger transaction_slot_error'
                defaultMessage='Transaction SLOT error'
            />
        )
    );
    static readonly TRANSACTION_SLOT_MOVED = new TransactionTrigger(
        TransactionTriggerName.TRANSACTION_SLOT_MOVED,
        (
            <FormattedMessage
                id='TransactionTrigger.transaction_slot_moved'
                description='The displayed value for the TransactionTrigger transaction_slot_moved'
                defaultMessage='Transaction SLOT moved'
            />
        )
    );
    static readonly TRANSACTION_SLOT_NOT_CLOSED = new TransactionTrigger(
        TransactionTriggerName.TRANSACTION_SLOT_NOT_CLOSED,
        (
            <FormattedMessage
                id='TransactionTrigger.transaction_slot_not_closed'
                description='The displayed value for the TransactionTrigger transaction_slot_not_closed'
                defaultMessage='Transaction SLOT not closed'
            />
        )
    );
    static readonly TRANSACTION_SLOT_NOT_OPENED = new TransactionTrigger(
        TransactionTriggerName.TRANSACTION_SLOT_NOT_OPENED,
        (
            <FormattedMessage
                id='TransactionTrigger.transaction_slot_not_opened'
                description='The displayed value for the TransactionTrigger transaction_slot_not_opened'
                defaultMessage='Transaction SLOT not opened'
            />
        )
    );
    static readonly TRANSACTION_SLOT_OPENED = new TransactionTrigger(
        TransactionTriggerName.TRANSACTION_SLOT_OPENED,
        (
            <FormattedMessage
                id='TransactionTrigger.transaction_slot_opened'
                description='The displayed value for the TransactionTrigger transaction_slot_opened'
                defaultMessage='Transaction SLOT opened'
            />
        )
    );
    static readonly TRANSACTION_SLOT_UNLOCKED = new TransactionTrigger(
        TransactionTriggerName.TRANSACTION_SLOT_UNLOCKED,
        (
            <FormattedMessage
                id='TransactionTrigger.transaction_slot_unlocked'
                description='The displayed value for the TransactionTrigger transaction_slot_unlocked'
                defaultMessage='Transaction SLOT unlocked'
            />
        )
    );
    static readonly TRANSACTION_DELEGATED_TO_RECEIVER = new TransactionTrigger(
        TransactionTriggerName.TRANSACTION_DELEGATED_TO_RECEIVER,
        (
            <FormattedMessage
                id='TransactionTrigger.transaction_delegate_to_receiver'
                description='The displayed value for the TransactionTrigger transaction_delegate_to_receiver'
                defaultMessage='Transaction delegated to receiver'
            />
        )
    );
    static readonly TRANSACTION_DELEGATED_TO_SENDER = new TransactionTrigger(
        TransactionTriggerName.TRANSACTION_DELEGATED_TO_SENDER,
        (
            <FormattedMessage
                id='TransactionTrigger.transaction_delegate_to_sender'
                description='The displayed value for the TransactionTrigger transaction_delegate_to_sender'
                defaultMessage='Transaction delegated to sender'
            />
        )
    );

    static override readonly ALL = [
        TransactionTrigger.TRANSACTION_ACCEPTED_BY_COURIER,
        TransactionTrigger.TRANSACTION_ACTUATOR_ERROR,
        TransactionTrigger.TRANSACTION_ANNOUNCED,
        TransactionTrigger.TRANSACTION_CANCEL,
        TransactionTrigger.TRANSACTION_CANCELLED,
        TransactionTrigger.TRANSACTION_COLLI_CANCELLED,
        TransactionTrigger.TRANSACTION_COLLI_FAILED,
        TransactionTrigger.TRANSACTION_COLLI_PROCESSED,
        TransactionTrigger.TRANSACTION_COMPLETE,
        TransactionTrigger.TRANSACTION_COURIER_TIMED_OUT,
        TransactionTrigger.TRANSACTION_DELIVERED_BY_COURIER,
        TransactionTrigger.TRANSACTION_DELIVERY_CONFIRMED,
        TransactionTrigger.TRANSACTION_DROP_OFF,
        TransactionTrigger.TRANSACTION_DROPPED_OFF,
        TransactionTrigger.TRANSACTION_FAILED,
        TransactionTrigger.TRANSACTION_HANDED_IN_BY_CUSTOMER,
        TransactionTrigger.TRANSACTION_LOST,
        TransactionTrigger.TRANSACTION_MIS_SORTED_BY_COURIER,
        TransactionTrigger.TRANSACTION_MOVE_SLOT,
        TransactionTrigger.TRANSACTION_MOVE_SPOT,
        TransactionTrigger.TRANSACTION_NOT_PICKED_UP_BY_CUSTOMER,
        TransactionTrigger.TRANSACTION_OPEN_SLOT,
        TransactionTrigger.TRANSACTION_PACKAGE_CANCELLED,
        TransactionTrigger.TRANSACTION_PACKAGE_FAILED,
        TransactionTrigger.TRANSACTION_PACKAGE_PROCESSED,
        TransactionTrigger.TRANSACTION_PICK_UP,
        TransactionTrigger.TRANSACTION_PICKED_UP,
        TransactionTrigger.TRANSACTION_PICKED_UP_BY_COURIER,
        TransactionTrigger.TRANSACTION_PICKED_UP_BY_CUSTOMER,
        TransactionTrigger.TRANSACTION_PIN_CODE_CREATED,
        TransactionTrigger.TRANSACTION_PIN_CODE_ENTERED,
        TransactionTrigger.TRANSACTION_PROCESS,
        TransactionTrigger.TRANSACTION_PROCESSED,
        TransactionTrigger.TRANSACTION_PROCESSED_WITH_FAILURES,
        TransactionTrigger.TRANSACTION_REDIRECTED_BY_COURIER,
        TransactionTrigger.TRANSACTION_SORTED_BY_COURIER,
        TransactionTrigger.TRANSACTION_SLOT_CANCELLED,
        TransactionTrigger.TRANSACTION_SLOT_CLOSED,
        TransactionTrigger.TRANSACTION_SLOT_ERROR,
        TransactionTrigger.TRANSACTION_SLOT_MOVED,
        TransactionTrigger.TRANSACTION_SLOT_NOT_CLOSED,
        TransactionTrigger.TRANSACTION_SLOT_NOT_OPENED,
        TransactionTrigger.TRANSACTION_SLOT_OPENED,
        TransactionTrigger.TRANSACTION_SLOT_UNLOCKED,
        TransactionTrigger.TRANSACTION_DELEGATED_TO_RECEIVER,
        TransactionTrigger.TRANSACTION_DELEGATED_TO_SENDER,
        TransactionTrigger.TRANSACTION_SPOT_MOVED,
        TransactionTrigger.TRANSACTION_STATE_CHANGED,
        ...super.ALL
    ];

    static override getByValue(trigger: TransactionTriggerName | WorkflowTriggerName): WorkflowTrigger | undefined {
        return this.ALL.find((a) => a.value == trigger);
    }
}
